module.exports = __webpack_public_path__ + "static/media/partnerships_page_image.c14fb2b6.jpg";